import ButtonLoader from "@components/ButtonLoader/ButtonLoader";
import SelectSeperated from "@components/selectSeperated/SelectSeperated";
import React, { useState } from "react";
import "./LinkedParents.scss";
import { ActionMeta, OnChangeValue } from "react-select";

interface Option {
  label: string;
  value: string;
}

const LinkedParents = () => {
  const [invait, setInvait] = useState<OnChangeValue<Option, true>>([]);
  return (
    <div className="LinkedParents">
      <div className="col-3">
        <ButtonLoader className="w-100 mt-3 mb-5">Invite</ButtonLoader>
      </div>
      <div className="LikedParents__MainWrapper"></div>
      <SelectSeperated onChange={(x) => setInvait(x)} values={invait} />
    </div>
  );
};

export default LinkedParents;
